export function Loading({ label = 'Loading tournament…' }: { label?: string }) {
  return <div className="grid min-h-[50vh] place-items-center"><div className="text-center"><div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-[var(--primary)]"/><p className="text-sm font-bold text-slate-500">{label}</p></div></div>;
}

